import { defineAction } from './types';

export default defineAction({
  action: 'DATA_UPLOAD',
  getHref: attrs => `/client/${attrs.client_id}/document/add`,
  getFollowUp: () => ({
    title: 'Upload client documents',
    message: 'Upload documents for this client. Afternoon will automatically extract key data.',
  }),
  completionEvents: ['DATA_UPLOADED'],
});
